import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { Subject, BehaviorSubject, takeUntil } from 'rxjs';
import {
  ActionCommentsList,
  ActionComment,
  ActionCommentsListPageChanged,
} from '../../action-comments.model';
import { AccordionService } from 'src/app/services/accordion.service';

@Component({
  selector: 'app-action-comments',
  templateUrl: './action-comments.component.html',
  styleUrls: ['./action-comments.component.scss'],
})
export class ActionCommentsComponent implements OnChanges, OnInit, OnDestroy {
  @Input()
  public titleLabel?: string;

  @Input()
  public commentsList: ActionCommentsList = { elements: [], totalEntries: 0 };

  @Input()
  public canAdd = false;

  @Input()
  public pageSize = 5;

  @Input()
  public parentId?: number;

  @Input()
  public showItemList = true;

  @Input()
  public openByDefault = false;

  @Output()
  public loadMore = new EventEmitter<ActionCommentsListPageChanged>();

  @Output()
  public toggleVisibility = new EventEmitter<void>();

  public readonly comments$ = new BehaviorSubject<ActionComment[]>([]);

  private currentPage = 1;
  private lastPage = 0;
  private destroyed$ = new Subject<void>();

  constructor(private accordionService: AccordionService) {}

  public ngOnInit(): void {
    this.comments$.next(this.commentsList.elements);
    this.lastPage = Math.ceil(this.commentsList.totalEntries / this.pageSize);
    this.currentPage = 1;

    // Open the accordion by default if specified
    if (this.openByDefault) {
      this.accordionService.openComponent('comments');
    }

    // Subscribe to accordion service to manage showItemList state
    this.accordionService
      .getCurrentOpenComponent()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((openComponentId) => {
        this.showItemList = openComponentId === 'comments';
      });
  }

  public ngOnChanges(): void {
    this.comments$.next(this.commentsList.elements);
    this.lastPage = Math.ceil(this.commentsList.totalEntries / this.pageSize);
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  public get hasMoreComments(): boolean {
    const hasMore = this.currentPage < this.lastPage;
    return hasMore;
  }

  public get hasComments(): boolean {
    return this.commentsList.elements.length > 0;
  }

  public loadMoreComments(): void {
    this.currentPage++;
    this.loadMore.next({
      pageNumber: this.currentPage,
      pageSize: this.pageSize,
    });
  }

  public showItems(): void {
    // Use accordion service to manage state
    if (this.showItemList) {
      this.accordionService.closeComponent('comments');
    } else {
      this.accordionService.openComponent('comments');
    }
  }

  public getCommentDate(dateString?: string): Date {
    return dateString ? new Date(dateString) : new Date();
  }
}
